module.exports = __webpack_public_path__ + "static/img/homeleft2.e6729a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/homeleft2.png
// module id = EnPi
// module chunks = 13